<template>
  <div>
    <!-- Hero Section -->
    <section class="hero">
      <div class="container">
        <h1>{{ $t('download.title') }}</h1>
        <p>{{ $t('download.subtitle') }}</p>
      </div>
    </section>

    <!-- Download Cards -->
    <section class="download-section">
      <div class="container">
        <h2 class="section-title">{{ $t('download.choosePlatform') }}</h2>
        <p class="section-subtitle">{{ $t('download.subtitle') }}</p>

        <div class="download-grid">
          <div class="download-card">
            <div class="os-icon">
              <svg viewBox="0 0 48 48" width="48" height="48"><path fill="#00adef" d="M40,38.9c-1.3,2.9-1.9,4.2-3.6,6.8c-2.4,3.6-5.7,8-9.2,8c-3.1,0-4-2-7.5-2s-4.6,1.9-7.5,2c-3.2,0.1-6.7-4.7-9.1-8.3C-1.7,37-0.5,24.3,4.6,19.7c3.5-3.2,7.5-5,11.6-5c3.6,0,5.9,1.9,8.8,1.9c2.8,0,4.5-2,8.5-2c3.5,0,6.7,1.6,9.1,4.2c-5.8,3.8-4.9,11.8,0.9,14.7C42.1,34.8,41.3,35.9,40,38.9z M30.4,7.4c1.6-2.2,2.8-5.2,2.3-8.4c-2.6,0.2-5.6,1.8-7.3,4c-1.5,2-2.8,5-2.3,7.9C25.9,11.2,28.7,9.7,30.4,7.4z"/></svg>
            </div>
            <h3>macOS</h3>
            <p class="os-version">macOS 11+ · Intel & Apple Silicon</p>
            <a href="https://github.com/turingevo/Omni-note/releases/latest" class="btn btn-primary btn-block" target="_blank">
              <span>⬇</span> {{ $t('download.downloadFor') }} macOS
            </a>
          </div>

          <div class="download-card">
            <div class="os-icon">💻</div>
            <h3>Windows</h3>
            <p class="os-version">Windows 10+ · x64</p>
            <a href="https://github.com/turingevo/Omni-note/releases/latest" class="btn btn-primary btn-block" target="_blank">
              <span>⬇</span> {{ $t('download.downloadFor') }} Windows
            </a>
          </div>

          <div class="download-card">
            <div class="os-icon">🐧</div>
            <h3>Linux</h3>
            <p class="os-version">Ubuntu 20.04+</p>
            <a href="https://github.com/turingevo/Omni-note/releases/latest" class="btn btn-primary btn-block" target="_blank">
              <span>⬇</span> {{ $t('download.downloadFor') }} Linux
            </a>
          </div>
        </div>

        <p class="github-link">
          <a href="https://github.com/turingevo/Omni-note/releases" target="_blank">GitHub Releases →</a>
        </p>
      </div>
    </section>

    <!-- Enterprise -->
    <section class="enterprise-section">
      <div class="container">
        <div class="enterprise-card">
          <div class="enterprise-icon">🏢</div>
          <h2>{{ $t('download.enterpriseTitle') }}</h2>
          <p>{{ $t('download.enterpriseDesc') }}</p>
          <ul class="enterprise-features-list">
            <li>{{ $t('download.advancedSecurity') }}</li>
            <li>{{ $t('download.multiUserSupport') }}</li>
            <li>{{ $t('download.centralizedManagement') }}</li>
            <li>{{ $t('download.dedicatedSupport') }}</li>
          </ul>
          <a href="mailto:wmx@turingevo.com" class="btn btn-secondary btn-lg">{{ $t('download.contactSales') }}</a>
        </div>
      </div>
    </section>

    <!-- System Requirements -->
    <section class="system-requirements">
      <div class="container">
        <h2 class="section-title">{{ $t('download.systemRequirements') }}</h2>
        <div class="requirements-grid">
          <div class="requirement-card">
            <h3>{{ $t('download.osRequirements') }}</h3>
            <ul>
              <li>Windows 10+ (x64)</li>
              <li>macOS 11+ (Intel & Apple Silicon)</li>
              <li>Ubuntu 20.04+ (AppImage)</li>
            </ul>
          </div>
          <div class="requirement-card">
            <h3>{{ $t('download.hardwareRequirements') }}</h3>
            <ul>
              <li>{{ $t('download.minRam') }}</li>
              <li>{{ $t('download.processor') }}</li>
              <li>{{ $t('download.diskSpace') }}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Download'
}
</script>

<style scoped>
.hero {
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
  color: white;
  padding: 100px 20px;
  text-align: center;
}

.hero h1 {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 20px;
}

.hero p {
  font-size: 1.25rem;
  color: #a0a0cc;
  max-width: 600px;
  margin: 0 auto;
}

.download-section {
  padding: 80px 20px;
  background: #f8f9fa;
  text-align: center;
}

.section-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: #222;
}

.section-subtitle {
  color: #666;
  margin-bottom: 40px;
}

.download-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  max-width: 900px;
  margin: 0 auto;
}

.download-card {
  background: white;
  border-radius: 16px;
  padding: 40px 24px;
  text-align: center;
  box-shadow: 0 4px 16px rgba(0,0,0,0.06);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.download-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(0,0,0,0.1);
}

.os-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  line-height: 1;
}

.os-icon svg {
  width: 48px;
  height: 48px;
}

.download-card h3 {
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 6px;
  color: #222;
}

.os-version {
  font-size: 0.85rem;
  color: #888;
  margin-bottom: 24px;
}

.btn-block {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px;
  font-size: 0.95rem;
}

.github-link {
  margin-top: 28px;
}
.github-link a {
  color: #667eea;
  font-size: 0.9rem;
  text-decoration: none;
}
.github-link a:hover {
  text-decoration: underline;
}

.enterprise-section {
  padding: 80px 20px;
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
  text-align: center;
}

.enterprise-card {
  max-width: 600px;
  margin: 0 auto;
  color: white;
}

.enterprise-icon {
  font-size: 3rem;
  margin-bottom: 16px;
}

.enterprise-card h2 {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 12px;
}

.enterprise-card > p {
  color: #a0a0cc;
  margin-bottom: 28px;
}

.enterprise-features-list {
  list-style: none;
  padding: 0;
  margin: 0 auto 32px;
  display: inline-block;
  text-align: left;
}

.enterprise-features-list li {
  padding: 8px 0;
  color: rgba(255,255,255,0.8);
}
.enterprise-features-list li::before {
  content: "✓ ";
  color: #29c840;
  font-weight: bold;
}

.system-requirements {
  padding: 80px 20px;
  background: #f8f9fa;
  text-align: center;
}

.requirements-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  max-width: 640px;
  margin: 40px auto 0;
}

.requirement-card {
  background: white;
  border-radius: 12px;
  padding: 28px 24px;
  text-align: left;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}

.requirement-card h3 {
  font-size: 1rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 16px;
}

.requirement-card ul {
  list-style: none;
  padding: 0;
}

.requirement-card li {
  padding: 6px 0;
  font-size: 0.9rem;
  color: #666;
  border-bottom: 1px solid #f5f5f5;
}

.requirement-card li:last-child {
  border-bottom: none;
}

.btn-lg {
  padding: 14px 36px;
  font-size: 1.05rem;
}

.enterprise-section .btn-secondary {
  border-color: rgba(255,255,255,0.3);
  color: white;
}
.enterprise-section .btn-secondary:hover {
  border-color: #667eea;
  background: rgba(102,126,234,0.15);
}

@media (max-width: 968px) {
  .download-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .hero h1 { font-size: 2rem; }
  .hero p { font-size: 1rem; }
  .download-grid,
  .requirements-grid {
    grid-template-columns: 1fr;
  }
}
</style>
